export default __webpack_public_path__ + "images/sponsor-icon.png?e43cd92a138c1f526ee7648bea19160d";